export const productAPiPath = {
  81: 'catering',
  82: 'office',
  83: 'shop',
  84: 'beauty',
  85: 'education',
  86: 'hair',
  88: 'medical',
  11: 'car',
  12: 'housemaid',
  13: 'holiday',
  14: 'travel',
  15: 'interior',
  16: 'student',
  17: 'home_fire',
  18: 'accident',
  20: 'home_fire',
  22: 'pet',
  80: 'sme'
}
export const smeClassId = {
  catering:81,
  office:82,
  shop:83,
  beauty:84,
  education:85,
  hair:86,
  medical:88,
}
